
import { getAuthHookFactory } from "../../../../global/paywall/useAuth";
import { AuthStepsEnum } from "../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallMobileSigninEmail } from "./signin/premiumPaywallMobileSigninEmail"
import { PremiumPaywallState } from "../desktop/premiumPaywallDesktop";
import PremiumPaywallCheckoutPlans from "../desktop/premiumPaywallPlans";
import { PremiumPaywallMobileSigninPassword } from "./signin/premiumPaywallMobileSigninPassword";
import { PremiumPaywallMobileSigninFinish } from "./signin/premiumPaywallMobileSigninFinish";



interface PremiumPaywallMobileLoginProps {
  email: string
  password: string
  agreesTerms: boolean
  setEmail: (email: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  setIsRedirecting: (isRedirect: boolean) => void
  isNewspaper?: boolean;
}

export const PremiumPaywallMobileSignin = (props: PremiumPaywallMobileLoginProps) => {
  const { email, setEmail, password, setPassword, setMode, agreesTerms,setIsRedirecting, isNewspaper} = props
  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailForLogin,
    submitPassword,
    proceedToEmailStep,
    user,
    setAuthError
  } = getAuthHookFactory("login")();


  const sendMail = () => {
    sendEmailForLogin(email, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => { 
    thirdPartyLogin(isNewCustomer)
  }


  switch (step) {
    case AuthStepsEnum.PLANS:
      return (  
        <PremiumPaywallCheckoutPlans
            proceedToEmailStep={proceedToEmailStep}
            setMode={setMode}
        />)
    case AuthStepsEnum.EMAIL:
      return (
            <PremiumPaywallMobileSigninEmail
            email={email}
            setEmail={setEmail}
            setMode={setMode}
            loginWithGoogle={loginWithGoogle}
            loginWithApple={loginWithApple}
            sendMail={sendMail}
            authError={authError}
            isNewspaper= {isNewspaper}
            setAuthError={setAuthError}
            />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumPaywallMobileSigninPassword
          email={email}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          sendMail={sendMail}
          authError={authError}
          setEmail={setEmail}
        />
      )

      case AuthStepsEnum.CONFIRM_TERMS:
        // if its sign in, we dont need to confirm terms
        onThirdPartyLogin(false)
        return null

      case AuthStepsEnum.FINISH:
          return <PremiumPaywallMobileSigninFinish user={user} setIsRedirecting={setIsRedirecting} />
    default:
      return null
  }
};
